import {PopupNotification} from "../../component/common/PopupNotification";
import {Spinner} from "../../component/common/Spinner";
import * as React from 'react';
import {Message} from "semantic-ui-react";
import {ICoreState} from "../../component/common/CoreState";

export class StateManager {

    public static setOnLoading(coreState: ICoreState) {
        coreState.popupNotification = <div/>;
        coreState.loadingNotification = <div/>;
        coreState.errorNotification = <div/>;
        coreState.isLoading = true;

        return coreState;
    }

    public static setOffLoading(coreState: ICoreState) {
        coreState.popupNotification = <div/>;
        coreState.loadingNotification = <div/>;
        coreState.errorNotification = <div/>;
        coreState.isLoading = false;

        return coreState;
    }

    public static showLoadingNotification(coreState: ICoreState) {
        coreState.popupNotification = <div/>;
        coreState.loadingNotification = <Spinner/>;
        coreState.errorNotification = <div/>;
        coreState.isLoading = true;

        return coreState;
    }

    public static hideLoadingNotification(coreState: ICoreState) {
        coreState.popupNotification = <div/>;
        coreState.loadingNotification = <div/>;
        coreState.errorNotification = <div/>;
        coreState.isLoading = false;

        return coreState;
    }

    public static showErrorNotification(coreState: ICoreState, errorMessage: string | undefined) {
        coreState.popupNotification = <div/>;
        coreState.loadingNotification = <div/>;
        coreState.errorNotification= <Message
            error={true}
            header='Error'
            content={errorMessage}
        />;
        coreState.isLoading = false;

        return coreState;
    }

    public static showPopupNotification(coreState: ICoreState, title: string, message: string | undefined, closeAction: () => void) {
        coreState.popupNotification = <PopupNotification closeAction={closeAction} title={title} description={message} />;
        coreState.loadingNotification = <div/>;
        coreState.errorNotification= <div/>;
        coreState.isLoading = false;

        return coreState;
    }

    public static clearNotification(coreState: ICoreState) {
        coreState.popupNotification = <div/>;
        coreState.loadingNotification = <div/>;
        coreState.errorNotification= <div/>;
        coreState.isLoading = false;

        return coreState;
    }

}


// WEBPACK FOOTER //
// ./src/core/utility/StateManager.tsx